module.exports = __webpack_public_path__ + "images/cd0d26fe0a75876f2dfbf81c70311b74.svg";